import { useEffect, useRef, useState } from 'react';

import { IGlobalToEuropeRedirectPopUpViewModel } from 'Scripts/Types/Litium';

import useLockedBody from 'Hooks/useLockedBody';

import CtaButton from 'Components/CtaButton';

import CloseIcon from 'Icons/close.svg?react';

interface ModalProps {
    globalToEuropeRedirectPopUpModel: IGlobalToEuropeRedirectPopUpViewModel;
    isOpened: boolean;
    onClose?: () => void;
}

export const GlobalToEuropeRedirectPopUp = ({
    isOpened,
    onClose,
    globalToEuropeRedirectPopUpModel,
}: ModalProps) => {
    const ref = useRef<HTMLDialogElement>(null);
    const [isClosing, setIsClosing] = useState(true);
    const [, setLocked] = useLockedBody(false);

    useEffect(() => {
        if (isOpened) {
            setIsClosing(false);
            setLocked(true);
            ref.current.showModal();
        } else {
            setIsClosing(true);
        }
    }, [isOpened]);

    return (
        <dialog
            ref={ref}
            onCancel={e => {
                e.preventDefault();
                e.stopPropagation();
            }}
            className={`scroll-bar-gsd::-webkit-scrollbar scroll-bar-gsd::-webkit-scrollbar-thumb scroll-bar-gsd mt-[20%] h-[250px] w-[600px] rounded-lg border border-solid border-gray-400 transition-all duration-500 ease-in-out backdrop:transition-all backdrop:duration-500 backdrop:ease-in-out lg:mt-[10%] [&:modal]:flex [&:modal]:flex-col [&:modal]:flex-wrap ${
                isClosing
                    ? 'invisible opacity-0 backdrop:invisible backdrop:bg-black/0 backdrop:opacity-0'
                    : 'visible opacity-100 backdrop:visible backdrop:bg-black/40 backdrop:opacity-100 '
            } `}
        >
            <div className="flex min-h-full flex-col p-6">
                <h2 className="under mb-4 text-center font-montserrat text-h4 leading-tight">
                    {globalToEuropeRedirectPopUpModel.headerText}
                </h2>
                <div className="flex h-[80%] w-full items-center justify-evenly gap-7 font-montserrat underline">
                    <button onClick={onClose}>
                        {globalToEuropeRedirectPopUpModel.stayOnGlobalText}
                    </button>
                    <a
                        className="text-center font-montserrat underline"
                        href={
                            globalToEuropeRedirectPopUpModel
                                .redirectToEuropeLink.href
                        }
                    >
                        {
                            globalToEuropeRedirectPopUpModel
                                .redirectToEuropeLink.text
                        }
                    </a>
                </div>
                <div className="flex w-full items-center justify-center">
                    <CtaButton onClick={onClose}>
                        {globalToEuropeRedirectPopUpModel.closeText}
                    </CtaButton>
                </div>
            </div>

            <button
                className="absolute right-2.5 top-2.5 flex"
                onClick={onClose}
                type="button"
            >
                <CloseIcon className="h-6 w-6 cursor-pointer">
                    <span>{globalToEuropeRedirectPopUpModel.closeText}</span>
                </CloseIcon>
            </button>
        </dialog>
    );
};
